import { ref } from 'vue'

export function useLastSoldPrices() {
  const loading = ref(false)
  const lastSoldPrices = ref([])

  const fetchLastSoldPrices = async (customerId) => {
    if (!customerId) {
      lastSoldPrices.value = []
      return Promise.resolve()
    }

    loading.value = true
    try {
      const response = await fetch(`/customers/${customerId}/last_sold_prices`)
      const data = await response.json()
      lastSoldPrices.value = data.products || []
    } catch (error) {
      console.error('Failed to fetch last sold prices:', error)
      lastSoldPrices.value = []
    } finally {
      loading.value = false
    }
  }

  const getLastSoldPrice = (productId) => {
    const item = lastSoldPrices.value.find(p => p.product_id === productId)
    return item?.last_sold_price || null
  }

  return {
    loading,
    lastSoldPrices,
    fetchLastSoldPrices,
    getLastSoldPrice
  }
}
